import { DO_LOADING, DO_TRIGGER } from 'redux/actions/loading';
import { GET_PROFILE } from 'redux/actions/profile';

const initialState = {
  data: [],
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PROFILE: {
      return {
        ...state,
        data: payload,
      };
    }

    default:
      return state;
  }
};
